<div class="kt-footer kt-grid__item" id="kt_footer">
  @if (useBottomDiv) {
    <div [class]="containerClass">
      <div class="kt-footer__bottom">
        <div class="kt-footer__copyright">
          UPM | &copy; {{today | date:'yyyy'}}
        </div>
        <div class="kt-footer__menu">
        </div>
      </div>
    </div>
  }
  @if (!useBottomDiv) {
    <div [class]="containerClass">
      <div class="kt-footer__wrapper">
        <div class="kt-footer__copyright">
          UPM | &copy; {{today | date:'yyyy'}}
        </div>
        <div class="kt-footer__menu">
        </div>
      </div>
    </div>
  }
</div>